import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterLeftElements>
        <FooterTitle>
          <NavLink to={'/'}><span>@Minecraft</span>listing.ca 2024, all rights reserverd.</NavLink>
        </FooterTitle>
        <DiscordLink href="https://discord.gg/fFxHmywVsF" target="_blank" rel="noopener noreferrer">
        Join our Discord
      </DiscordLink>
      </FooterLeftElements>
    </FooterWrapper>
  )
}

const FooterWrapper = styled.section`
  background-color: #fff;
  display: flex;  
  padding: 2.5rem;
  flex-direction: row;
  justify-content: space-between;
  box-shadow: 1px 1px 9px 1px #27800d;
  width: 100%;
  flex-wrap: wrap;
  gap: 3rem
`;

const DiscordLink = styled.a`
  display: inline-block;
  padding: 10px 20px;
  color: white;
  background-color: #7289da;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;
  font-weight: 500;
  font-size: 2rem;

  &:hover {
    background-color: #5b6eae;
  }
`;

const FooterTitle = styled.section`
  font-size: 2rem;
  
  a {

    span {
      color: #3BA61C;
      font-weight: 500; 
    }

    color: #58678C;
    font-weight: 500;
  }
`;

const FooterLeftElements = styled.section`
  display: flex;
  align-items: center;
  gap: 3rem;
  width: 100%;
  justify-content: space-between;
`;
 

export default Footer